import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { IMenuProps } from './menu-props.interface';
import styled from 'styled-components';
import { getLinkFinalURL } from '../../../util/url/get-link-final-url';
import { LinkOriginEnum } from '../../../enum/link-origin.enum';
import { DropdownRouteWrapper } from './atoms';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { IMainMenuItem } from '../../../interface/main-menu-item.interface';
import { action, observable } from 'mobx';
import { MenuArrowRightIcon } from '../../icons';
import { MENU_ITEM_WIDTH } from './consts';
import { Ellipsis } from '../../ellipsis';
import { isServerSide } from '../../../util/server-side-rendering/is-server-side';

interface IDropdownMenuProps extends Pick<IMenuProps, Exclude<keyof IMenuProps, 'logoAlignment'>> {
  onCloseMenu: () => void;
  left: number;
  top: number;
  submenuDirection: number;
}

interface IDropdownMenuItemProps extends Pick<IDropdownMenuProps, Exclude<keyof IDropdownMenuProps, 'items'>> {
  item: IMainMenuItem;
}

interface IDropdownWrapperProps {
  left: number;
  top: number;
}

const DropdownWrapper = styled.div`
  position: absolute;
  top: ${(props: IDropdownWrapperProps) => props.top}px;
  left: ${(props: IDropdownWrapperProps) => props.left}px;
`;

@observer
class MenuItem extends React.Component<IDropdownMenuItemProps & IInjectedProps> {
  @observable submenuDirection: number = 1;
  @observable submenuOpacity: number = 1;
  @observable subMenuShown: boolean = false;
  removeEventListener;

  @action
  componentWillMount() {
    this.submenuDirection = this.props.submenuDirection;
    this.submenuOpacity = this.props.backgroundOpacity;
    if (!isServerSide()) {
      const callHide = () => {
        this.props.onCloseMenu();
      };
      document.addEventListener('click', callHide);
      this.removeEventListener = () => {
        document.removeEventListener('click', callHide);
      };
    }
  }

  componentWillUnmount() {
    if (this.removeEventListener) {
      this.removeEventListener();
    }
  }

  @action
  showSubMenu = () => {
    const currentLeft = ReactDOM.findDOMNode(this).getBoundingClientRect().left;
    if (this.submenuDirection === 1 && currentLeft + MENU_ITEM_WIDTH * 2 > this.props.state.windowSize.width) {
      this.submenuDirection = -1;
    }
    if (this.submenuDirection === -1 && currentLeft - MENU_ITEM_WIDTH < 0) {
      this.submenuDirection = 1;
      if (currentLeft + MENU_ITEM_WIDTH * 2 > this.props.state.windowSize.width) {
        this.submenuDirection = 0.1;
        if (currentLeft + MENU_ITEM_WIDTH + this.submenuDirection * MENU_ITEM_WIDTH > this.props.state.windowSize.width) {
          this.submenuDirection = -1 * this.submenuDirection;
        }
      }
    }
    if (this.props.submenuDirection !== this.submenuDirection) {
      this.submenuOpacity = 1;
    }
    this.subMenuShown = true;
  }

  @action
  hideSubMenu = () => this.subMenuShown = false

  render() {
    const {item} = this.props;
    const url = getLinkFinalURL(this.props.state, item.link);
    return <DropdownRouteWrapper
      key={item.id}
      color={this.props.textColor}
      backgroundColor={this.props.backgroundColor}
      opacity={this.props.backgroundOpacity}
      hoverColor={this.props.hoverTextColor}
      isSelected={this.props.state.activeDesign.data && item.link && item.link.origin === LinkOriginEnum.Internal && item.link.pageId === this.props.state.activeDesign.page.id}
      onClick={item.subItems && item.subItems.length > 0 ? undefined : this.props.onCloseMenu}
      onMouseEnter={item.subItems && item.subItems.length > 0 ? this.showSubMenu : undefined}
      onMouseLeave={item.subItems && item.subItems.length > 0 ? this.hideSubMenu : undefined}
      to={item.subItems && item.subItems.length > 0 ? undefined : url}
    >
      <Ellipsis style={{display: 'block', flex: '1 1 100%', textAlign: 'left'}}>
        {item.label}
      </Ellipsis>
      {item.subItems && item.subItems.length > 0 && <MenuArrowRightIcon />}
      {this.subMenuShown ?
        <DropdownMenu key={item.id} left={this.submenuDirection * MENU_ITEM_WIDTH} submenuDirection={this.submenuDirection} top={0} items={item.subItems} textColor={this.props.textColor} menuStyle={this.props.menuStyle} inEditor={this.props.inEditor} hoverTextColor={this.props.hoverTextColor} backgroundOpacity={this.submenuOpacity} backgroundColor={this.props.backgroundColor} onCloseMenu={this.props.onCloseMenu} /> : undefined}
    </DropdownRouteWrapper>;
  }
}

@inject('state')
export class DropdownMenu extends React.Component<IDropdownMenuProps & IInjectedProps> {
  render() {
    const {items} = this.props;
    return <DropdownWrapper left={this.props.left} top={this.props.top}>
      {items.map(item => <MenuItem key={item.id} item={item} {...this.props}/>)}
    </DropdownWrapper>;
  }
}